import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import SingleInstallment from '../components/singleinstallment';
import ProfileHeader from '../components/ProfileHeader';
import { useDispatch, useSelector } from 'react-redux';
import {
    setAllInstallments,
    setSelectedInstallments,
    setPayzero,
    setObligatoryInstallmentNumber,
    setEntryFee,
    setAllInstallmentsPriceReducer
} from '../reducers/reposReducers';
import ConvertNumber from '../components/ConvertNumber';
import ApiService from '../services/ApiService';
import ParsMonth from '../services/ParsMonth';
import NotificationService from '../services/NotificationService';
import EDSFooter from '../components/EDSFooter';

const Wybor_opcji_5_raty = () => {
    const key = useSelector((state) => state.repos.chName);
    if (!key || key == '') {
        
        history.push(`/LoginBuy/key=${localStorage.getItem('keyURL')}`);
    }
    const promotionsData = useSelector((state) => state.repos.promotionsData);
    const apiService = ApiService.getInstance();
    const parsMonth = ParsMonth.getInstance();
    const notificationService = NotificationService.getInstance();
    const history = useHistory();
    const [getSchedule, setgetSchedule] = useState(true);
    const startDate = useSelector((state) => state.repos.date);
    const [paymentSchedule, setPaymentSchedule] = useState([]);
    const [allInstallmentsPrice, setAllInstallmentsPrice] = useState(0);
    const [selected, setSelected] = useState([]);
    const [selectedUser, setSelectedUser] = useState(0);
    const [sumPayUser, setsumPayUser] = useState(0);
    const [obligatoryDataProvided, setObligatoryDataProvided] = useState(false);
    const [entryFeeData, setEntryFeeData] = useState({
        price: 99,
        priceDiscount: 0,
        discountCash: 99,
        discountProcent: 100,
    });
    const dispatchPrice = useDispatch();
    const dispatch = useDispatch();
    const dispatchPaymentziro = useDispatch();


    const selectedInstallments = useSelector((state) => state.repos.selectedInstallments);

    const obligatoryInstallmentNumber = useSelector((state) => state.repos.index);

    const paymentData = useSelector((state) => {
        return state.repos.payForm;
    });

    const selectedProduct = useSelector((state) => {
        return state.repos.groups;
    });

    const promotionsSalesIDArray = useSelector((state) => {
        return state.repos.promotionsSalesIDArray;
    });

    const selectedParticipant = useSelector((state) => {
        return state.repos.usersParticipant;
    });

    const setInstallmentSelection = (cena, index) => {
        if (cena > 0) {
            const select = () => {
                const arr = [...selected];
                arr.push(index);
                setSelected(arr);
                setAllInstallmentsPrice(allInstallmentsPrice + cena);
                dispatch(setSelectedInstallments(arr));
            };

            const unselect = () => {
                const arr = selected.filter((item) => item !== index);
                setSelected(arr);
                setAllInstallmentsPrice(allInstallmentsPrice - cena);
                dispatch(setSelectedInstallments(arr));
            };

            const i = selected.indexOf(index);
            if (i > -1) {
                unselect();
            } else {
                select();
            }
        }
    };

    useEffect(() => {
        if (
            typeof paymentData === 'object' &&
            paymentData !== null &&
            typeof paymentData.selectedPaymentMethod === 'number' &&
            paymentData.selectedPaymentMethod > 0 &&
            typeof startDate === 'string' &&
            startDate.length > 0 &&
            typeof selectedProduct === 'object' &&
            selectedProduct !== null &&
            typeof selectedProduct.productsID === 'number' &&
            selectedProduct.productsID > 0 &&
            typeof selectedProduct.coursesHeadingsID === 'number' &&
            selectedProduct.coursesHeadingsID > 0 
        ) {
            setObligatoryDataProvided(true);

            if (
                typeof selectedParticipant === 'object' &&
                selectedParticipant !== null &&
                typeof selectedParticipant.usersID === 'number' &&
                selectedParticipant.usersID > 0
            ) {
                // related person is selected
                setSelectedUser(selectedParticipant.usersID);
                // initialize();
            } else {
                loadUserData((response) => {
                    if (response.success) {
                        setSelectedUser(response.data.usersID);
                        // initialize();
                    } else {
                        notificationService.showError();
                    }
                });
            }
        } else {
            console.error('not all obligatory was provided!');
            notificationService.showError();
        }
    }, []);

    useEffect(() => {
        // initialize after selectedUser is set
        if (typeof selectedUser === 'number' && selectedUser > 0) {
            initialize();
        }
    }, [selectedUser]);

    function loadUserData(callback) {
        apiService.apiGet('UserGet', (response) => {
            if (response.success) {
                if (typeof callback === 'function')
                    callback({ success: true, data: response.data });
            } else {
                if (typeof callback === 'function') callback({ success: false, data: null });
            }
        });
    }

    function initialize() {
        const numLength = selectedProduct.paymentShedule.length-1;
        const calculateSchedulePayload = {
            paymentMethodsDVID: paymentData.selectedPaymentMethod,
            startDate: startDate,
            usersID: selectedUser,
            productsID: selectedProduct.productsID,
            coursesHeadingsID: selectedProduct.coursesHeadingsID,
            promotionsSalesIDList: promotionsSalesIDArray? promotionsSalesIDArray.join(','): '',
            dataTo: selectedProduct.paymentShedule[numLength]?.periodToDate,
            current_LocalizationsID: 0,
        };
    
        apiService.apiPost('CalculateProductForUser', calculateSchedulePayload, (response) => {
            if (response.success) {
                if (
                    response.data.responseStatusCode === 200 &&
                    typeof response.data.responseBody === 'object' &&
                    response.data.responseBody !== null &&
                    response.data.responseBody.status === '200'
                ) {
                    const data = response.data.responseBody.body;

                    if (
                        typeof data.paymentShedule === 'object' &&
                        Array.isArray(data.paymentShedule) &&
                        typeof data.entryFee !== 'undefined'
                    ) {
                        if (
                            typeof data.entryFee === 'object' &&
                            typeof data.entryFee.price === 'number' &&
                            typeof data.entryFee.priceDiscount === 'number' &&
                            typeof data.entryFee.discountCash === 'number' &&
                            typeof data.entryFee.discountProcent === 'number'
                        ) {
                            setEntryFeeData(data.entryFee);
                            dispatch(setEntryFee(data.entryFee));
                        } else {
                            const obj = {
                                price: 99,
                                priceDiscount: 0,
                                discountCash: 99,
                                discountProcent: 100,
                            };
                            setEntryFeeData(obj);
                            dispatch(setEntryFee(obj));
                        }

                        // filter the installments with nonzero price only
                        const filteredSchedule = data.paymentShedule.filter(
                            (item) => item.paymentPositionPrice > 0
                            
                        );
                        
                        setgetSchedule(data.entryFee);
                        setPaymentSchedule(filteredSchedule);
                        dispatch(setAllInstallments(filteredSchedule));

                        let num = 0;
                        filteredSchedule.map(e => {
                            num = num + e.paymentPositionPrice;
                        })
 
                        setsumPayUser(num);
                        const toSelect = new Set();
                        if (filteredSchedule.length > 0) {
                            const firstSchedule = filteredSchedule[0];

                            dispatch(setObligatoryInstallmentNumber(firstSchedule.countNumber));

                            // always select first installment
                            toSelect.add(firstSchedule.countNumber);

                            // restore all saved installments
                            if (
                                typeof selectedInstallments === 'object' &&
                                Array.isArray(selectedInstallments)
                            ) {
                                for (const item of selectedInstallments) {
                                    toSelect.add(item);
                                }
                            }
                        }

                        const selectedIds = [];
                        let totalPrice = 0;

                        for (const installment of filteredSchedule) {
                            if (toSelect.has(installment.countNumber)) {
                                selectedIds.push(installment.countNumber);
                                totalPrice += installment.paymentPositionPriceDiscount;
                            }
                        }

                        setSelected(selectedIds);
                        dispatch(setSelectedInstallments(selectedIds));
                        setAllInstallmentsPrice(totalPrice);
                    } else {
                        notificationService.showError();
                    }
                } else {
                    notificationService.showError();
                }
            } else {
                notificationService.showError();
            }
        });
    }

    const save = (e) => {
        for (let i = 0; i < paymentSchedule.length; i++) {
            var num = 0;
            if (paymentSchedule[i].paymentPositionPrice > 0 && num === 0) {
                num = paymentSchedule[i].paymentPositionPriceDiscount;
                dispatchPaymentziro(setPayzero({
                    paymentPositionPriceDiscount: paymentSchedule[i].paymentPositionPriceDiscount,
                    paymentPositionPrice: paymentSchedule[i].paymentPositionPrice}));
                break;
            }
        }
        e.preventDefault();
        localStorage.setItem('suma', allInstallmentsPrice + entryFeeData.priceDiscount);
        dispatchPrice(setAllInstallmentsPriceReducer(sumPayUser))
        history.push('/umowa');
    };

    function render() {
        return (
            <>
                <header className="header">
                    <div className="header__image-box">
                        <a href="">
                            <img
                                src={logo_pop}
                                alt="Logo Egurrola Dance Studio"
                                className="header__image"
                            />
                        </a>
                    </div>
                    <div className="header__caption-box">
                        <span className="header__caption">
                            Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                        </span>
                    </div>
                </header>
                <div className="content">
                    <a href="#">
                        <Link to="/Wybor_opcji_4_forma_platnosci">
                            <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                        </Link>
                    </a>
                    <ProfileHeader></ProfileHeader>
                    <aside className="registration-steps margin-top-32">
                        <div className="step">
                            <div className="step__circle step__circle--active">
                                <span className="step__count">1</span>
                            </div>
                            <span className="step__text">Wybór&nbsp;kursu</span>
                        </div>
                        <div className="step">
                            <div className="step__circle">
                                <span className="step__count">2</span>
                            </div>
                            <span className="step__text">Umowa</span>
                        </div>
                        <div className="step">
                            <div className="step__circle">
                                <span className="step__count">3</span>
                            </div>
                            <span className="step__text">Płatność</span>
                        </div>
                    </aside>
                    <aside className="registration-course-steps margin-top-16">
                        <span className="step">Uczestnik</span>
                        <div className="hyphen"></div>
                        <span className="step">Data</span>
                        <div className="hyphen"></div>
                        <span className="step">Wariant</span>
                        <div className="hyphen"></div>
                        <span className="step">Forma płatności i rabat</span>
                        <div className="hyphen"></div>
                        <span className="step step--active">Raty</span>
                    </aside>

                    {obligatoryDataProvided ? renderContent() : <></>}
                </div>

                <EDSFooter></EDSFooter>
            </>
        );
    }

    function renderContent() {
        return (
            <main className="responsive-padding">
                <section className="course-options-payment margin-top-64">
                    <h2 className="h2">Raty</h2>
                    <form
                        id="pay-installments-form"
                        method="post"
                        action=""
                        onSubmit={(e) => save(e)}
                    >
                        {renderInstallmentsTable()}
                        {getSchedule? renderEntryFeeSummary(): ''}

                        <ul className="pay-installments-sums margin-top-32">
                            <span className="pay-installments-sums__item-title">
                                Kwota do zapłaty:
                            </span>
                            <span className="pay-installments-sums__item-value">
                                <span id="pay-installments">
                                    {ConvertNumber(
                                        allInstallmentsPrice + entryFeeData.priceDiscount
                                    )}
                                </span>{' '}
                                zł
                            </span>
                        </ul>

                        <div className="pay-installments-submit-box margin-top-32">
                            <input
                                type="submit"
                                className="pay-installments-submit btn-primary-responsive"
                                value="Dalej"
                            />
                        </div>
                    </form>
                </section>
            </main>
        );
    }

    function renderTableHeaderRow() {
        return (
            (promotionsData.selectedPromotions.length > 0) ? <tr>
                <th>
                    <div>Nr raty</div>
                </th>
                <th>
                    <div>Kwota</div>
                </th>
                <th>
                    <div>Rabat procentowy</div>
                </th>
                <th>
                    <div>Rabat kwotowy</div>
                </th>
                <th>
                    <div>Kwota po rabatach</div>
                </th>
                <th>
                    <div>Miesiąc raty</div>
                </th>
                <th>
                    <div>Termin płatności</div>
                </th>
                <th>
                    <div>Wybierz</div>
                </th>
            </tr> :
            <tr>
                <th>
                    <div>Nr raty</div>
                </th>
                <th>
                    <div>Kwota</div>
                </th>
                {/* <th>
                    <div>Rabat procentowy</div>
                </th>
                <th>
                    <div>Rabat kwotowy</div>
                </th>
                <th>
                    <div>Kwota po rabatach</div>
                </th> */}
                <th>
                    <div>Miesiąc raty</div>
                </th>
                <th>
                    <div>Termin płatności</div>
                </th>
                <th>
                    <div>Wybierz</div>
                </th>
            </tr>
        );
    }

    function renderInstallmentsTable() {
        return (
            <div className="responsive-table">
                <table className="pay-installments-table margin-top-32">
                    <caption className="pay-installments-table__caption h3">
                        Wybierz raty do opłacenia
                    </caption>
                    <thead>{renderTableHeaderRow()}</thead>
                    <tbody>
                        {paymentSchedule.map((el, index) =>
                            el.paymentPositionPrice > 0 ? (
                                <SingleInstallment
                                    key={el.countNumber}
                                    countNumber={el.countNumber}
                                    paymentDate={el.paymentDate}
                                    paymentPositionPrice={el.paymentPositionPrice}
                                    paymentPositionPriceDiscount={el.paymentPositionPriceDiscount}
                                    isFullUnitOfAccount={el.isFullUnitOfAccount}
                                    isVoid={el.isVoid}
                                    periodFromDate={el.periodFromDate}
                                    periodToDate={el.periodToDate}
                                    discountCash={el.discountCash}
                                    discountProcent={el.discountProcent}
                                    setSelection={setInstallmentSelection}
                                    chckd={selected.includes(el.countNumber)}
                                    index={obligatoryInstallmentNumber}
                                    manth={parsMonth.manth}
                                    selectedPromotions={promotionsData.selectedPromotions}
                                />
                            ) : (
                                ''
                            )
                        )}
                    </tbody>

                    <tfoot className="tfoot_text_left">
                        <tr>
                            <td colSpan={4}>{/* Oszczędzasz:  */}</td>
                            <td colSpan={4}>
                                Do zapłaty: {ConvertNumber(allInstallmentsPrice)} zł
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }

    function renderEntryFeeSummary() {
        return (
            (promotionsData.selectedPromotions.length > 0) ?
            <div className="responsive-table">
                <table className="pay-installments-table margin-top-32">
                    <caption className="pay-installments-table__caption h3">Opłata wpisowa</caption>
                    <thead className="invisible_header">{renderTableHeaderRow()}</thead>
                    <tbody>
                        <tr className="grayed_row">
                            <td></td>
                            <td>{ConvertNumber(entryFeeData.price)} zł</td>
                            <td>- {ConvertNumber(entryFeeData.discountProcent)}%</td>
                            <td>- {ConvertNumber(entryFeeData.discountCash)} zł</td>  
                            <td className="installment-total"> 
                                {ConvertNumber(entryFeeData.priceDiscount)} zł
                            </td>  
                            <td></td>
                            <td></td>
                            <td><input
                                    className="form__checkbox"
                                    type="checkbox"
                                    checked={true}
                                    disabled={true}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            : 
             <div className="responsive-table">
                <table className="pay-installments-table margin-top-32">
                    <caption className="pay-installments-table__caption h3">Opłata wpisowa</caption>
                    <thead className="invisible_header">{renderTableHeaderRow()}</thead>
                    <tbody>
                        <tr className="grayed_row">
                            <td></td>
                            <td>{ConvertNumber(entryFeeData.price)} zł</td>
                            {/* <td>- {ConvertNumber(entryFeeData.discountProcent)}%</td>
                            <td>- {ConvertNumber(entryFeeData.discountCash)} zł</td> */}
                            <td className="installment-total">
                                {ConvertNumber(entryFeeData.priceDiscount)} zł
                            </td>   
                            <td></td>
                            <td></td>
                            <td><input
                                    className="form__checkbox"
                                    type="checkbox"
                                    checked={true}
                                    disabled={true}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return render();
};
export default Wybor_opcji_5_raty;
